export default [
  {
    path: "/03d1a7ec62cd19d86a51a4cc",
    children: [
      {
        path: "XyGHA0439b9c210598592dd51ecb99k0",
        name: "add-product",
        meta: {
          title: "Add product",
          authRequired: true,
          acc: ["y48700"],
        },
        component: () => import("@/views/product/create.vue"),
      },
      {
        path: "XyGHA03a61fe9b54605efc10f55409k0",
        name: "product-list",
        meta: {
          title: "products",
          authRequired: true,
          acc: ["y99595"],
        },
        component: () => import("@/views/product/index.vue"),
      },
      {
        path: "XyGHA0042efda1241cd4a0b6a47d1709k0/:id?",
        name: "product-view",
        meta: {
          title: "product",
          authRequired: true,
          acc: ["y25981"],
        },
        component: () => import("@/views/product/details.vue"),
      },
      {
        path: "XyGHA04897e583a9c3785fb7db28ek0/:id?",
        name: "product-edit",
        meta: {
          title: "Edit product",
          authRequired: true,
          acc: ["y50075"],
        },
        component: () => import("@/views/product/create.vue"),
      },
    ],
  },
];
